import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function LockOpenIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M21.9 10.84H10.1V9.6c0-3.4 2.64-6.15 5.9-6.15a5.87 5.87 0 0 1 5.16 3.17c.32.6 1.04.8 1.6.48.58-.33.78-1.08.47-1.67A8.09 8.09 0 0 0 12 2.08 8.67 8.67 0 0 0 7.74 9.6v1.75a6.16 6.16 0 0 0-3.54 5.62v7.38a6.02 6.02 0 0 0 5.9 6.14h11.8c3.26 0 5.9-2.75 5.9-6.14v-7.38c0-3.4-2.64-6.14-5.9-6.14ZM17.18 21.9A1.2 1.2 0 0 1 16 23.13a1.2 1.2 0 0 1-1.18-1.23v-2.46c0-.68.53-1.23 1.18-1.23.65 0 1.18.55 1.18 1.23v2.46Z"
      />
    </BaseIcon>
  );
}
